import { inject, Injectable } from '@angular/core';
import { Logo } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  DarkSiteAem,
  HeaderFooterMachCoreContentService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { LogoAdapterService } from '../../adapters/logo/logo-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class LogoFacadeService {
  logoAdapter = inject(LogoAdapterService);
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  logoDetails$ = new BehaviorSubject<Logo>({} as Logo);
  isDarkSiteEnabled$ = new BehaviorSubject<DarkSiteAem>({} as DarkSiteAem);

  init(): void {
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .pipe(take(1))
      .subscribe((content) => {
        this.logoDetails$.next(this.logoAdapter.getContent(content));
        this.isDarkSiteEnabled$.next(this.logoAdapter.darkSiteThemeContent);
      });
  }
}
